import { Card, CardContent } from "@/components/ui/card";

export const StatCard = ({ label, value, sub, icon: Icon, color = "emerald" }) => (
  <Card className="bg-card border-border/50">
    <CardContent className="p-4 flex items-center gap-4">
      <div className={`w-11 h-11 rounded-xl bg-${color}-100 flex items-center justify-center flex-shrink-0`}>
        <Icon className={`w-5 h-5 text-${color}-600`} />
      </div>
      <div className="min-w-0">
        <p className="text-2xl font-black text-foreground">{value}</p>
        <p className="text-xs text-muted-foreground">{label}</p>
        {sub && <p className="text-[10px] text-muted-foreground/60">{sub}</p>}
      </div>
    </CardContent>
  </Card>
);
